import moment from 'moment';

import { getCurrentUser } from '../services/store-service';

const getLocalHour = (hour, reverse) => {
    const localHour = hour + (getCurrentUser().tz || 0) / 60 * (reverse ? 1 : -1);

    if (localHour > 24) {
        return localHour - 24;
    }

    if (localHour < 0) {
        return 24 + localHour;
    }

    return localHour;
}

const getFriendlyDayName = (day, short) => {
    let dayName;
    switch (day.toString()) {
        case '0':
            dayName = 'Sunday';
            break;
        case '1':
            dayName = 'Monday';
            break;
        case '2':
            dayName = 'Tuesday';
            break;
        case '3':
            dayName = 'Wednesday';
            break;
        case '4':
            dayName = 'Thursday';
            break;
        case '5':
            dayName = 'Friday';
            break;
        case '6':
            dayName = 'Saturday';
            break;

        default:
            // es lint
    }

    if (short) {
        return dayName[0];
    }

    return dayName;
}

export const encodeCronString = params => {
    const result = [];

    if (params.cronStartAt) {
        const [ hours, minutes ] = params.cronStartAt.split(':');

        if (!hours || !minutes || isNaN(hours - 0) || isNaN(minutes - 0) || hours - 0 > 12 || minutes - 0 > 60) {
            return {
                error: true,
                message: 'Please enter valid At time'
            };
        }

        const fullHours = moment(hours + params.cronStartAtMidnight, 'HHa').format('HH');
        const localHours = Math.round(getLocalHour(fullHours - 0, true));

        result.push(minutes - 0);
        result.push(localHours);
    } else {
        result.push('*', '*')
    }

    if (params.cronType === 'month') {
        if (!params.cronDayOfMonth || isNaN(params.cronDayOfMonth - 0) || params.cronDayOfMonth - 0 > 31) {
            return {
                error: true,
                message: 'Please enter month day between 1-31'
            };
        }

        result.push(params.cronDayOfMonth);
    } else {
        result.push('*');
    }

    result.push('*');

    if (params.cronType !== 'month') {
        if (!params.cronDayOfWeek.length) {
            return {
                error: true,
                message: 'Please select the day(s) for this task.'
            };
        }

        result.push(params.cronDayOfWeek.join(','));
    } else {
        result.push('*');
    }

    return result.join(' ');
}

export const decodeCronString = (cronString = '') => {
    if (!cronString) {
        return {
            cronType: null,
            cronStartAt: '09:00',
            cronStartAtMidnight: 'am',
            cronDayOfMonth: 1,
            cronMonth: null,
            cronDayOfWeek: []
        };
    }

    const [ startAtMinute, startAtHour, dayOfMonth, month, dayOfWeek ] = cronString.split(' ');

    let cronDayOfWeek = dayOfWeek === '*' ? [] : dayOfWeek.split(',');
    const cronDayOfMonth = dayOfMonth === '*' ? '' : dayOfMonth;
    let localStartAtHour = getLocalHour(startAtHour - 0);

    if (localStartAtHour >= 24) {
        localStartAtHour -= 24;
    } else if (localStartAtHour < 0) {
        localStartAtHour += 24;
    }

    return {
        cronType: cronDayOfMonth ? 'month' : (cronDayOfWeek.length !== 1 ? 'day' : 'week'),
        cronStartAt: moment(`${localStartAtHour}:${startAtMinute}`, 'HH:mm').format('hh:mm'),
        cronStartAtMidnight: moment(localStartAtHour, 'HH').format('a'),
        cronDayOfMonth,
        cronMonth: month === '*' ? '' : month,
        cronDayOfWeek
    };
}

export const getUserFriendlyCron = cronString => {
    const cronProps = decodeCronString(cronString);

    const startAt = `${cronProps.cronStartAt}${cronProps.cronStartAtMidnight.toUpperCase()}`;

    if (cronProps.cronType === 'month') {
        return `Monthly on ${cronProps.cronDayOfMonth} at ${startAt}`;
    }

    if (cronProps.cronType === 'week' || cronProps.cronDayOfWeek.length === 1) {
        return `Weekly on ${getFriendlyDayName(cronProps.cronDayOfWeek[0])} at ${startAt}`;
    }

    if (cronProps.cronDayOfWeek.length === 7) {
        return `Daily at ${startAt}`;
    }

    return `${cronProps.cronDayOfWeek.map(day => getFriendlyDayName(day, true)).join(', ')} at ${startAt}`;
}
